A code classifying the primary method of payment for a position.
